import { makeAPICall } from "../../utils/common";
import config from "../../utils/config";

export function triggerDashboardAudit(obj) {
  const params = {
    url: `${config.apiBasePath.baseIp}dashboardAudit`,
    type: "POST",
    headers: obj.headers,
    params: obj.params,
  };
  makeAPICall(params);
}
